<template>
  <v-layout row wrap align-start fill-height pb-5>
    <v-flex xs12>
      <v-layout row wrap align-center mt-2 mb-2>
        <v-flex xs12>
          <v-card class="pa-2">
            <div class="d-inline-flex">
              <v-layout row align-center>
                <span class="mr-2">{{$lang.labels.from}}</span>
                <v-menu
                    ref="menuFromOrders"
                    :close-on-content-click="false"
                    v-model="menuFromOrders"
                    :return-value.sync="fromDateOrders"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px">
                  <v-btn slot="activator" flat outline color="primary" class="ml-0 mr-auto">{{
                      formatDate(fromDateOrders)
                    }}
                  </v-btn>
                  <v-btn slot="activator" fab flat dark small color="primary" class="mr-0">
                    <v-icon dark>edit</v-icon>
                  </v-btn>
                  <v-date-picker v-model="fromDateOrders" @input="$refs.menuFromOrders.save(fromDateOrders)" no-title
                                 scrollable
                                 color="primary"/>
                </v-menu>
              </v-layout>
              <v-layout row align-center>
                <span class="mx-2">{{$lang.labels.to}}</span>
                <v-menu
                    ref="menuTillOrders"
                    :close-on-content-click="false"
                    v-model="menuTillOrders"
                    :return-value.sync="toDateOrders"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px">
                  <v-btn slot="activator" flat outline color="primary" class="ml-0 mr-auto">{{
                      formatDate(toDateOrders)
                    }}
                  </v-btn>
                  <v-btn slot="activator" fab flat dark small color="primary" class="mr-0">
                    <v-icon dark>edit</v-icon>
                  </v-btn>
                  <v-date-picker v-model="toDateOrders" @input="$refs.menuTillOrders.save(toDateOrders)" no-title
                                 scrollable
                                 color="primary"/>
                </v-menu>
              </v-layout>
              <v-btn
                  :disabled="loading"
                  color="primary"
                  class="mx-0"
                  @click="initialOrderSearch = true; searchOrders()">
                {{ $lang.labels.search }}
              </v-btn>
            </div>
            <v-flex xs12 pt-2 fill-height v-if="!ordersResult || (ordersResult && ordersResult.length === 0)">
              <v-layout fow wrap>
                <v-flex xs12 v-if="loading">
                  <br>
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </v-flex>
                <v-flex xs12 v-if="err">
                  <v-alert
                      color="error"
                      class="err"
                      icon="warning"
                      value="true"
                      v-if="err">{{ err }}
                  </v-alert>
                </v-flex>
                <v-flex xs12 v-if="ordersResult && ordersResult.length === 0 && searchType === 'orders'">
                  <v-alert
                      color="error"
                      class="err"
                      icon="warning"
                      value="true">No orders found.
                  </v-alert>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 pt-2 fill-height v-if="ordersResult && ordersResult.length > 0">
                <v-layout fow wrap>
                  <v-flex xs12>
                    <v-data-table
                        :headers="headers"
                        :items="ordersResult"
                        :rows-per-page-items="[50]"
                        :pagination.sync="pagination"
                        :total-items="totalOrdersResult"
                        disable-initial-sort
                        disable-sort
                    >
                      <template slot="items" slot-scope="props">
                        <td class="text-xs-left">{{ formatDateTime(props.item.deliveryTime) }}</td>
                        <td class="text-xs-left">
                          <span>{{ props.item.contact.firstName }} {{ props.item.contact.lastName }}</span>
                          <br v-if="props.item.contact.address">
                          <span v-if="props.item.contact.address" style="font-size: 11px">
                    {{
                              generateAddress([
                                props.item.contact.address.line1,
                                props.item.contact.address.line2,
                                props.item.contact.address.line3,
                                props.item.contact.address.line4,
                              ])
                            }}
                    <br v-if="props.item.contact.address">
                    {{ props.item.contact.address.locality ? props.item.contact.address.locality + ', ' : '' }}
                    {{
                              props.item.contact.address.country === 'UK' ? props.item.contact.address.townCity : props.item.contact.address.postalCode
                            }},
                    {{
                              props.item.contact.address.country === 'UK' ? props.item.contact.address.postalCode : props.item.contact.address.townCity
                            }}

                    </span>
                        </td>
                        <td class="text-xs-left">{{ $lang.actions[props.item.type] }}</td>
                        <td class="text-xs-left">{{ company ? company.currencySymbol + props.item.totalAmount.toFixed(2) : '' }}</td>
                        <td class="text-xs-left">
                          <template v-for="star in 5">
                            <v-icon :key="star"
                                    size="19"
                                    :color="props.item.ratingStars >= star ? 'primary' : ''">star
                            </v-icon>
                          </template>
                        </td>
                        <td class="text-xs-left">
                          <v-btn color="primary" @click="order = props.item;orderDetails = true;">{{ $lang.labels.details }}</v-btn>
                        </td>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-dialog v-if="orderDetails" v-model="orderDetails" max-width="1200">
      <order-details :order="order" @close="orderDetails = false"/>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
// import auth from '../auth';

export default {
  name: 'OrdersSearch',
  components: {
    orderDetails: () => import('../webshop/modals/OrderDetails'),
  },
  data() {
    return {
      order: null,
      orderDetails: false,
      searchType: 'orders',
      err: '',
      loading: false,
      fromDateOrders: moment()
        .subtract(14, 'd')
        .startOf('d')
        .toISOString(),
      menuFromOrders: false,
      toDateOrders: moment()
        .endOf('d')
        .toISOString(),
      menuTillOrders: false,
      ordersResult: null,
      pagination: {},
      totalOrdersResult: 0,
      headers: [
        {
          text: this.$lang.header.deliveryTime,
          align: 'left',
          sortable: false,
          value: 'deliveryTime',
        },
        {
          text: this.$lang.header.customer,
          align: 'left',
          sortable: false,
          value: 'contact.firstName',
        },
        {
          text: this.$lang.labels.deliveryType,
          align: 'left',
          sortable: false,
          value: 'type',
        },
        {
          text: this.$lang.global.total,
          align: 'left',
          sortable: false,
          value: 'totalAmount',
        },
        {
          text: this.$lang.header.rating,
          align: 'left',
          sortable: false,
          value: 'stars',
        },
        {
          text: this.$lang.labels.actions,
          align: 'left',
          sortable: false,
          value: 'id',
        },
      ],
      initialOrderSearch: true,
    };
  },
  watch: {
    pagination: {
      handler() {
        if (!this.initialOrderSearch && !this.loading) {
          this.searchOrders();
        } else {
          this.initialOrderSearch = false;
        }
      },
      immediate: false,
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      company: 'company',
      companyActive: 'companyActive',
    }),
  },
  methods: {
    generateAddress(lines) {
      return lines.filter(line => !!line)
        .join(', ');
    },
    formatDate(date) {
      return date ? moment(date)
        .format('YYYY-MM-DD') : this.$lang.actions.selectDate;
    },
    formatDateTime(date) {
      return moment(date)
        .format('DD/MM/YYYY HH:mm');
    },
    searchOrders() {
      this.ordersResult = null;
      this.err = '';
      this.searchType = 'orders';
      if (!this.fromDateOrders || !this.toDateOrders) {
        this.err = 'Please select both dates';
        setTimeout(() => {
          this.err = '';
        }, 6000);
        return;
      }
      this.loading = true;
      this.$webHelper.get(`order/list?from=${moment(this.fromDateOrders).toISOString()}&to=${moment(this.toDateOrders).toISOString()}&page=${this.pagination.page || 1}`)
        .then((res) => {
          if (res.body && res.status === 200) {
            this.ordersResult = res.body.details.sort((a, b) => {
              const keyA = new Date(a.deliveryTime);
              const keyB = new Date(b.deliveryTime);
              // Compare the 2 dates
              if (keyA > keyB) return -1;
              if (keyA < keyB) return 1;
              return 0;
            });
            this.totalOrdersResult = res.body.pagesCount * 50;
            setTimeout(() => {
              this.loading = false;
            }, 50);
          } else {
            this.err = res.body.statusText;
            setTimeout(() => {
              this.err = '';
            }, 6000);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.err = err;
          setTimeout(() => {
            this.err = '';
          }, 6000);
          this.loading = false;
        });
    },
  },
  created() {
    this.searchOrders();
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/OrdersAdmin/OrdersSearch.vue